<script>
  import { project } from "$lib/services/store";
  import "../../../../app.postcss";

  export let data;

  project.set(data.project);
</script>

<slot />